<template>
  <b-row>
    <b-col cols="12">
      <tabela-repeticao
        v-model="imItens"
        name="inscricaoMunicipal"
        :colunas="imColunas"
        :validar="validar"
      >
        <template #visualizacao="{slotScope: { valor, key, tipo}}">
          <span v-if="tipo === 'data'">{{ dataFormatada(valor) }}</span>
          <span v-else>
            {{ key==='municipio' ? valor.nome : valor }}
          </span>

        </template>

        <template #edicao="{slotScope: {item, key, tipo}}">
          <municipio-select
            v-if="key === 'municipio'"
            v-model="item[key]"
            :invalido="item.erro && item.erro[key]"
          />

          <div v-else-if="tipo === 'data'">
            <data-input
              v-model="item[key]"
              :caledario="false"
              :invalid="item.erro && item.erro[key]"
              :required="false"
            />
          </div>

          <b-input
            v-else
            v-model="item[key]"
            :class="{'is-invalid' : item.erro && item.erro[key]}"
          />
        </template>
      </tabela-repeticao>
    </b-col>
  </b-row>
</template>

<script>
import { formatDate } from '@core/utils/filter'
import { mapGetters } from 'vuex'

export default {
  name: 'IncricaoMunicipal',
  components: {
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
  },
  data() {
    return {
      valueInner: [],
      imColunas: [
        { key: 'im', label: 'Inscrição' },
        { key: 'municipio', label: 'Município' },
        { key: 'dataEmissao', label: 'Data de emissão', tipo: 'data' },
        { key: 'dataBaixa', label: 'Data de baixa', tipo: 'data' },
      ],
    }
  },
  computed: {
    ...mapGetters('empresa', ['imItens']),
  },
  methods: {
    dataFormatada(data) {
      if (data && (data instanceof Date || data.indexOf('T') > 0)) {
        return formatDate(data, { month: 'numeric', day: 'numeric', year: 'numeric' })
      }
      return data
    },
    validar(item) {
      this.$set(item, 'erro', {})

      if (!item.im) {
        this.$set(item.erro, 'im', true)
        return false
      }
      if (item.im && item.im.toLowerCase() !== 'isento') {
        let valido = true
        if (!item.municipio || !item.municipio.nome) {
          this.$set(item.erro, 'municipio', true)
          valido = false
        }
        if (!item.dataEmissao) {
          this.$set(item.erro, 'dataEmissao', true)
          valido = false
        }
        return valido
      }
      return true
    },
  },
}
</script>
